export default function ConfirmModal({
  eventName,
  actionType = "archive",
  onConfirm,
  onCancel,
}) {
  const isArchive = actionType === "archive";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 16,
      }}
    >
      <div
        style={{
          background: "var(--color-bg-card)",
          borderRadius: "var(--radius-lg)",
          padding: 24,
          maxWidth: 340,
          width: "100%",
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-display)",
            fontSize: "var(--text-h3)",
            fontWeight: "var(--font-semibold)",
            color: "var(--color-text-primary)",
            marginBottom: 8,
          }}
        >
          {isArchive ? "Archiwizuj wydarzenie" : "Przywróć wydarzenie"}
        </div>
        <div
          style={{
            fontSize: "var(--text-body)",
            color: "var(--color-text-muted)",
            marginBottom: 24,
            lineHeight: "var(--leading-ui)",
          }}
        >
          {isArchive ? (
            <>
              Czy na pewno chcesz zarchiwizować <strong>{eventName}</strong>?
              Wydarzenie zostanie oznaczone jako nieaktywne.
            </>
          ) : (
            <>
              Czy na pewno chcesz przywrócić <strong>{eventName}</strong>?
              Wydarzenie zostanie ponownie oznaczone jako aktywne.
            </>
          )}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              border: "1px solid var(--color-border)",
              background: "var(--btn-ghost-bg)",
              color: "var(--btn-ghost-text)",
              borderRadius: "var(--radius-md)",
              padding: "11px 12px",
              fontWeight: "var(--font-medium)",
              fontSize: "var(--text-body)",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Anuluj
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              border: "none",
              background: isArchive ? "var(--btn-destructive-bg)" : "var(--color-success)",
              color: isArchive ? "var(--btn-destructive-text)" : "var(--color-white)",
              borderRadius: "var(--radius-md)",
              padding: "11px 12px",
              fontWeight: "var(--font-medium)",
              fontSize: "var(--text-body)",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            {isArchive ? "Archiwizuj" : "Przywróć"}
          </button>
        </div>
      </div>
    </div>
  );
}
